import cx from 'classnames';
import React from 'react';
export const FormLegend = ({ children, className, looksLike = 'h5', ...rest }) => (React.createElement("legend", { className: cx({
        [`tds-text--${looksLike}`]: looksLike,
    }, className), ...rest }, children));
